import { createFileRoute } from "@tanstack/react-router";
import { TermsPage, termsHead } from "@/features/legal-documents";

export const Route = createFileRoute("/terms")({
    component: TermsPage,
    head: termsHead,
});
